import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface RicardoPerezProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const RicardoPerez = (props: RicardoPerezProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h4 className="section-title">
                    RECEB<br />
                    (RİCARDO PEREZ) <br />
                </h4>

                <p className="text-bold">
                    İslam’la müşerref olan Receb’in hidayet öyküsünü kendi ağzından dinleyelim:
                </p>
                <p>
                    Küçük yaşlarımdan itibaren kendimi Hıristiyanlık inanç ve terbiyesiyle yetiştiren, üstelik ruhuma İslam’a ve Müslümanlara karşı kin ve düşmanlık tohumlarını eken Katolik bir anne babadan dünyaya geldim. Hıristiyanlığı çok seviyordum. Devamlı dini kitaplar okuyup araştırmalarla kendimi bu alanda geliştiriyordum. Bu çalışmalarım ve aldığım eğitimler neticesinde Kardinalliğe kadar yükseltildim. Ve insanlara doğruyu anlatmak için çalışıyorduk. Bu süreçteki araştırma ve çalışmalarım beni farklı bir yöne yönlendirdi. Gittiğim vaazlar ve düzenlenen konferanslar neticesinde içimde sanki yeni ufuklar açılıyordu.
                </p>

                <p>
                    Bir ses bana: “Çalış doğruyu bul.” diyordu. Gönül penceremden hidayet güneşinin bana gülümsediğini hissediyordum. Bazı arkadaşlarıma gördüğüm değişik rüyaları anlatıyordum. Bana İslam’a çok yaklaştığımı ve temkinli davranmamı telkin ediyorlardı.
                </p>

                <p>
                    Bir gün Papa maiyetinde İstanbul’a geldik. Ortodoks Kilisesiyle ortak düzenlenen ayine katıldık. Ve birçok ziyaretler gerçekleştirdik.
                </p>
                <p>
                    Kadıköy Altıyol’daki Katolik kilisesinin başpapazı iken
                    o güne kadar yapmış olduğu faaliyetleri papaya bu görüşme neticesinde anlattım. O güne kadar 284 kişinin Hristiyan Katolik olduğunun raporunu verdim. Yanımda iki papaz daha vardı. Fernando Simoes ve Fernandes idiler.
                </p>

                <p>
                    Bu ziyaretlerin neticesinde Rehber Edip Bey vesilesiyle Sufilerle tanıştık.
                </p>
                <p>
                    Papa’nın ziyaretinin akabinde Rehber Edip Bey biz üç papazı sufi liderleri olan Ali Yakub Baba’nın Fatih’teki Zaviyesine davet etti. Oraya gittiğimiz gün pazar günü idi. O gün Sema programı vardı. Sema Ayin-i Şerifi izledik. Fakat Edip Bey o gün gelemediği için Ali Yakub Baba ile görüşemedik. Sonraki hafta tekrar Zaviyeye gittik. O günkü görüşme neticesinde üçümüz aynı gün İslam ile müşerref olduk.
                </p>
                <p>
                    Sufilerle tanışmış olmamız, sufilerin namazları, zikirleri, semaları ve ardından yapmış olduğumuz samimi sohbetler bizi çok etkilemişti. Bendeniz ise sufi liderlerinden muhtelif İncil’lerde araştırdığım sorularımı ve şüphelerimi gideren cevaplar aldım. Ve hayatımda ilk defa çok mutlu olduğumu hissettim.
                </p>
                <p>
                    <span className="text-bold">“Amentü billahi ve melâiketihi, ve kütübihî ve rusülihî ve’l yevmi’l-âhıri ve bi’lkaderi, hayrihî ve şerrihi mina’llâhi teâlâ ve’lba’sü ba’de’l mevt. Hakkun, Eşhedü en lâ ilâhe illallâh ve eşhedü enne Muhammeden abdühû ve rasûlühü.” </span> deyip kelime-i şehadet getirerek İslam’la müşerref oldum.
                </p>
                <p>
                    <span className="text-bold">İslam’ın esasları olan Kelime-i Şahadet, Namaz, Oruç, Zekât ve Hac </span> bana talim buyruldu.
                </p>

                <p>
                    <span className="text-bold">Receb </span>ismini aldım.
                </p>

                <p>
                    Papa ile beraber bu iki arkadaşım İstanbul’dan ayrıldı. Ben ise İstanbul’da kaldım.
                </p>

                <p>
                    İslam olduktan sonra 28 gün daha kilisede kaldım. Ardından istifa ettim. Artık huzurumun kaçtığını ve İstanbul’ da kalamayacağımı hissediyordum. Bir süre sonra İspanya’ya geri döndüm.
                </p>

                <p>
                    Eski dindaşlarımın da bu nurlu yolu bulup bu güzelliği yaşamaları için gece gündüz dua ediyorum.
                </p>
            </article>
        </div>
    );
}

export default RicardoPerez;